<template lang="html">
  <v-dialog v-model="isVisible" scrollable>
    <v-card class="grey lighten-4">
      <v-toolbar flat color="grey lighten-4">
        <v-icon class="mr-1">mdi-domain</v-icon>
        <v-toolbar-title class="text--secondary">BusinessUnit</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="toggleBusinessUnitPanel()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <template v-slot:extension>
          <v-tabs v-model="tab" grow background-color="grey lighten-4">
            <v-tab>All</v-tab>
            <v-tab>RetailStore</v-tab>
            <v-tab>WebSite</v-tab>
            <v-tab>Marketplace</v-tab>
          </v-tabs>
        </template>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text class="pa-0">
        <v-tabs-items v-model="tab" grow>
          <v-tab-item>
            <v-container>
              All...
            </v-container>
          </v-tab-item>
          <v-tab-item>
            <v-container>
              RetailStore...
            </v-container>
          </v-tab-item>
          <v-tab-item>
            <v-container>
              WebSite...
            </v-container>
          </v-tab-item>
          <v-tab-item>
            <v-container>
              Marketplace...
            </v-container>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
      <v-card-actions>
        <v-btn block color="blue" dark @click="toggleBusinessUnitPanel()"><v-icon>mdi-check</v-icon>apply</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

</template>

<script>
import {SEARCH_NS} from "@/store/modules/search/constants";
import { mapActions } from 'vuex'


export default {
  data: () => ({
    tab: ''
  }),
  computed: {
    isVisible: {
      get() {
        return this.$store.getters[`${SEARCH_NS}/isBusinessUnitPanelVisible`]
      },
      set() {
        this.$store.dispatch(SEARCH_NS + '/toggleBusinessUnitPanel')
      }
    }
  },
  methods: {
    ...mapActions(SEARCH_NS,['toggleBusinessUnitPanel']),
  }
}
</script>
